module.exports = __webpack_public_path__ + "media/images/img/tag_company/loglass_tag-9db4fb6753bd61a6de2365c8f1124ea6.png";